// removed by extract-text-webpack-plugin
module.exports = {"column":"c-Column__column","small":"c-Column__small"};